module.exports = __webpack_public_path__ + "static/img/btk.398d36e.png";


//////////////////
// WEBPACK FOOTER
// ./static/temporary_images/btk.png
// module id = +Kdc
// module chunks = 5